<template>
  <div class="fill-height">
    <v-card class="fill-height"  >

        <v-row  v-if="model.status==='Ok'">
          <v-col cols="12" sm="6" offset-sm="3"  >
            <v-card flat>
              <v-card-title class="mb-3" style="text-align: right;background-color: green; color: white" >
                پرداخت با موفقیت انجام شد
              </v-card-title>
              <v-card rounded class="p-2">
                <v-col class="m-1 p-0">
                <v-card-text   style="background-color: lightgray;border-radius: 5px" >
                    <span>مبلغ پرداختی:</span>
<!--                    <v-spacer/>-->
                    <span> {{model.amountText}} ریال</span>
                </v-card-text>
                </v-col>
                <v-col   class="m-1 p-0">
                <v-card-text style="background-color: lightgray;border-radius: 5px"  >
                  <span>شماره مرجع:</span>
<!--                  <v-spacer/>-->
                  <span> {{model.rrn}}</span>
                </v-card-text>
                </v-col>
                <v-col   class="m-1 p-0">
                  <v-card-text style="background-color: lightgray;border-radius: 5px" >
                    <span>شماره ترمینال:</span>
                    <span> {{model.terminalid}}</span>
                  </v-card-text>
                </v-col>
               <v-col   class="m-1 p-0">
                <v-card-text style="background-color: lightgray;border-radius: 5px" >
                  <span>تاریخ و ساعت :</span>
                  <span> {{model.paymentDateText}}</span>
                </v-card-text>
               </v-col>
                <v-col   class="m-1 p-0">
                <v-card-text style="background-color: lightgray;border-radius: 5px" >
                  <span>شماره کارت :</span>

                  <span>  {{model.cardnumber}}</span>
                </v-card-text>
                </v-col>
              </v-card>
            </v-card>


          </v-col>
        </v-row>
        <v-row  v-if="model.status!=='Ok'"  >
          <v-col cols="12" sm="6" offset-sm="3"  >
            <v-card flat>
              <v-card-title class="mb-3"  style="text-align: right;background-color: red; color: white" >
                پرداخت ناموفق بود
              </v-card-title>
              <v-card rounded class="p-2">
                <v-col   class="m-1 p-0">
              <v-card-text style="background-color: lightgray;border-radius: 5px"   > مبلغ پرداختی:{{model.amountText}} ریال</v-card-text>
                </v-col>
                <v-col   class="m-1 p-0">
                  <v-card-text  style="background-color: lightgray;border-radius: 5px"  >تاریخ :{{model.paymentDateText}}</v-card-text>
                </v-col>
            </v-card>
            </v-card>
          </v-col>
        </v-row>

      <v-card-actions dir="ltr">
        <v-btn
            small
            depressed
            color="warning"
            class=" pr-1 pl-1"
           @click="closed"

        >
        بازگشت به صفحه اصلی
        </v-btn>
        <v-btn
            small
            depressed
            color="success"
            class=" pr-1 pl-1 m-2"
            @click="download"

        >
          دانلود رسید پرداخت
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import 'jspdf-autotable'
import Account_se from "@/views/define/account/Account_se";
import {mapMutations} from "vuex";


export default {
  name: 'PCBsi',
  data() {
    return {
      id: '',
      model: {},
      result: false,

    }
  },
  methods: {
    download() {
      Account_se.exportPdf(this.id)
    },

    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.$root.$emit('Account')
      this.$router.push("/home")
    },


    getCallBack: function () {
      this.id = this.$route.params.id
      Account_se.getCallBackParsian(this.id).then(response => {
        this.model = response.data.model

      })
    },


  },
  created() {
    this.setDrawer(false)
    this.getCallBack()
  }
}


</script>


